import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { Layouts } from '../app.component';
import { HomePageComponent } from './home-page.component';

const routes: Routes = [
  {
    path: 'home-page', component: HomePageComponent,
    data: { layout: Layouts.SecureLayout }
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class HomePageRoutingModule { }
